// (c) chaehongee. Confidential and proprietary.

import { useEffect, useState } from 'react'
import type { ReactElement } from 'react'
import styles from '../Backstage.module.css'

interface Recommendation {
    id: string
    label: string
    prompt: string
}

interface RecommendationBubblesProps {
    disabled?: boolean
    onSelect: (prompt: string) => void
    recommendations?: Recommendation[]
    onRefresh?: () => void
    isRefreshing?: boolean
}

export function RecommendationBubbles({
    disabled = false,
    onSelect,
    recommendations = [],
    isRefreshing = false,
}: RecommendationBubblesProps): ReactElement | null {
    const [isDismissed, setIsDismissed] = useState(false)
    const recommendationsKey = recommendations
        .map((rec) => `${rec.id}:${rec.label}`)
        .join('|')

    useEffect(() => {
        if (recommendations.length > 0) {
            setIsDismissed(false)
        }
    }, [recommendationsKey, recommendations.length])

    if (disabled) return null
    if (isDismissed) return null
    if (recommendations.length === 0 && !isRefreshing) return null

    const handleSelect = (rec: Recommendation) => {
        onSelect(rec.prompt)
    }

    return (
        <div className={styles.recommendationContainer}>
            <div className={styles.recommendationHeader}>
                <button
                    className={styles.recommendationDismiss}
                    type="button"
                    aria-label="Dismiss recommendations"
                    onClick={() => setIsDismissed(true)}
                >
                    ×
                </button>
            </div>
            <div
                className={[
                    styles.recommendationBubbles,
                    isRefreshing ? styles.recommendationBubblesHidden : '',
                ].join(' ').trim()}
            >
                {recommendations.map((rec) => (
                    <button
                        key={rec.id}
                        className={styles.recommendationBubble}
                        onClick={() => handleSelect(rec)}
                        disabled={disabled}
                        type="button"
                    >
                        {rec.label}
                    </button>
                ))}
            </div>
        </div>
    )
}
